import { useSelector } from "react-redux";
import SessionWarnings from "../SessionWarnings";

const ONE_HOUR_MS = 60 * 60 * 1000;

const AutoLogout = () => {
  const { lastActivity, isAuthenticated } = useSelector((state) => state.auth);

  if (!isAuthenticated) return null;

  return (
    <SessionWarnings
      lastActivity={lastActivity}
      timeout={ONE_HOUR_MS} // 1 Hour
    />
  );
};

export default AutoLogout;